import React, { Component } from 'react'
import SostaOnlineApiService from "../../../../../services/SostaOnlineApiService";
import moment from "moment";
import Modal from 'react-responsive-modal'

const Text = (props) => <div className={props.bold ? 'text-bold-user ' + props.className : 'text-regular-user ' + props.className} {...props}>{props.children}</div>

class Summary extends Component {
    constructor (props) {
        super(props)
        this.state = {
            loading: false,
            errors: {},
            waitingList: {},
            closeWaitingListOpen: false,
            closingWaitingListErrors: null,
            closingWaitingList: false,
            sendingMail: false
        }
    }

    async componentDidMount () {
        this.setState({loading: true})
        await this.fetchWaitingList()
        this.setState({loading: false})
    }

    fetchWaitingList = async () => {
        const { match } = this.props
        const { params } = match
        const { id } = params
        const result = await SostaOnlineApiService.fetchWaitingList(id)
        if (result.result !== 'ok') {
            const { errors } = this.state
            this.setState({
                errors: {
                    ...errors,
                    submit: 'Erorre durante la ricezione della Lista d\'Attesa'
                }
            })
            return
        }

        const { data } = result
        this.setState({
            waitingList: data
        })
    }

    sendMailToUsers = async () => {
      try {
        const {match} = this.props
        const {params} = match
        const {id} = params
        this.setState({sendingMail: true})
        const result = await SostaOnlineApiService.sendOpenMailToAllWaitingListUsers(id)
        await this.fetchWaitingList()
        this.setState({sendingMail: false})
      } catch (e) {
        console.error(e)
        this.setState({sendingMail: false})
      }
    }

    closeWaitingList = async () => {
        const { closingWaitingList } = this.state

        if (closingWaitingList) {
            return
        }

        const { match } = this.props
        const { params } = match
        const { id } = params

        try {
            this.setState({closingWaitingList: true, closingWaitingListErrors: null})
            const response = await SostaOnlineApiService.closeWaitingList(id)
            if (response.result !== 'ok') {
                this.setState({
                    closingWaitingListErrors: 'Errore durante la chiusura della lista',
                    closingWaitingList: false
                })
            } else {
                this.setState({
                    closingWaitingList: false,
                    closeWaitingListOpen: false
                })
                await this.fetchWaitingList()
            }
        } catch (e) {
            console.log(e)
            this.setState({closingWaitingList: false, closingWaitingListErrors: e.error || 'Errore imprevisto durante la chiusura della lista'})
        }
    }

    render () {
        const { waitingList, loading, sendingMail } = this.state

        let showSendMailToUsers = false
        let statusDescription = "N.D."
        let statusColor = '#000000'
        if (!loading && waitingList.startDate && waitingList.endDate) {
            const startDate = moment(waitingList.startDate)
            const endDate = moment(waitingList.endDate)
            const now = moment()

            const isBefore = now.isBefore(startDate)
            const isAfter = now.isAfter(endDate)
            const isWaitingListSubscribable = !(isBefore || isAfter)
            if (waitingList.status === 'closed') {
                statusDescription = "Chiusa"
                statusColor = '#FF413C'
                showSendMailToUsers = false
            } else if (waitingList.status === 'open' && isWaitingListSubscribable) {
                statusDescription = "Attiva, gli utenti possono sottoscriversi"
                statusColor = "#08BF02"
                showSendMailToUsers = true
            } else if (waitingList.status === 'open' && isBefore) {
                statusDescription = "In Attesa della data d'inizio"
                statusColor = "#ff9202"
                showSendMailToUsers = true
            } else if (waitingList.status === 'open' && isAfter) {
                statusDescription = "Terminata, in attesa di chiusura"
                statusColor = "#FF413C"
                showSendMailToUsers = false
            }
        }

        return (
          <div className="box">
              <div className="row">
                  <div className="col-md-2">
                      <img className="user-admin-logo" src={require('../../../../../assets/logo-contrassegno.png')} />
                  </div>
                  {loading ? (
                    <div className="text-info">Caricamento in corso...</div>
                  ) : (
                    <div className="col-md-10 text-left">
                        <Text>ID</Text>
                        <Text bold>{waitingList.id}</Text>
                        <Text>CATEGORIE ABILITATE</Text>
                        {!!waitingList.Categories && (
                          <Text bold>
                              {waitingList.Categories.map((item, index) => (
                                <React.Fragment key={`waiting-list-category-${index}`}>
                                    {item.name}
                                    <br />
                                </React.Fragment>
                              ))}
                          </Text>
                        )}
                        <Text>DATE DI APERTURA DELLA LISTA</Text>
                        <Text bold>
                            {
                                moment(waitingList.startDate).format('L HH:mm') +
                                ' - ' +
                                moment(waitingList.endDate).format('L HH:mm')
                            }
                        </Text>
                        <Text>NUMERO DI PARTECIPANTI</Text>
                        <Text bold>
                            {`${waitingList.subscriptions}/${waitingList.availabilityNumber}`}
                        </Text>
                        <Text>STATO</Text>
                        <Text style={{color: statusColor}} bold>
                            {statusDescription}
                        </Text>
                        {waitingList.status !== 'closed' && (
                          <a onClick={() => this.setState({closeWaitingListOpen: true})} style={{marginTop: 6, marginBottom: 15}} className="btn btn-info btn-lg">
                              CHIUDI LISTA
                          </a>
                        )}

                        {showSendMailToUsers && (
                          <React.Fragment>
                              <Text>INVIA MAIL DI AVVISO APERTURA LISTA A TUTTI GLI UTENTI INTERESSATI:</Text>
                              <a onClick={!sendingMail ? this.sendMailToUsers : null} style={{marginTop: 6, marginBottom: 15}} className="btn btn-info btn-lg">
                                  {!sendingMail ? 'INVIA MAIL' : 'INVIO IN CORSO...'}
                              </a>
                              {waitingList.mailSendedToUsers && (
                                <span style={{marginLeft: 10}} className="text-danger">
                                    ATTENZIONE! È già stata inviata una mail di avviso a tutti gli utenti
                                </span>
                              )}
                          </React.Fragment>
                        )}

                        <Text>ABBONAMENTO GENERATO</Text>
                        {waitingList.parkTicketType && (
                          <div style={{width: '50%'}}>
                              <div className="user-card">
                                  <div className="user-card-head-a">
                                      <h5 className="user-card-title">
                                          <span>ABBONAMENTO: <strong>{waitingList.parkTicketType && waitingList.parkTicketType.name}</strong></span>
                                      </h5>
                                  </div>
                                  <div className="user-card-body">
                                      <div className="row">
                                          <div style={{padding: 0, marginBottom: 6}} className="col-md-9">
                                              <span><strong>{waitingList.Categories.map(item => item.name + ' ')}</strong></span>
                                          </div>
                                          <div style={{padding: 0, marginBottom: 6}} className="col-md-3">
                            <span style={{marginLeft: 15}}>
                            ZON{waitingList.parkTicketType.Areas.length > 1 ? 'E: ' : 'A: '}
                                <strong>
                            {waitingList.parkTicketType.Areas.map(item => item.code + ' ')}
                            </strong>
                            </span>
                                          </div>
                                          <div style={{padding: 0, marginBottom: 5, marginTop: 5}} className="col-md-12">
                                              <span>TARGA: <strong>...</strong></span>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="border-div" />
                                  <div className="user-card-footer">
                                      <div className="row">
                                          <div style={{padding: 0, marginTop: 10, marginBottom: 5}} className="col-md-12">
                                              <span>EMESSO IL: <strong>...</strong></span>
                                          </div>
                                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                                              <span>VALIDO DAL <strong>{moment(waitingList.markStartDate).startOf('month').format('L')}</strong> AL <strong>{moment(waitingList.markStartDate).add(waitingList.numberOfMonths > 1 ? waitingList.numberOfMonths - 1 : 0, 'months').endOf('month').format('L')}</strong></span>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                        )}
                    </div>
                  )}
              </div>
              <Modal
                open={this.state.closeWaitingListOpen}
                onClose={() => this.setState({closeWaitingListOpen: false})}
                showCloseIcon={!this.state.closingWaitingList}
                closeOnEsc={false}
                closeOnOverlayClick={false}
                classNames={{modal: 'container'}}
              >
                  <React.Fragment>
                      <h3>Chiudi Lista d'Attesa</h3>
                      <div className="row">
                          <div className="col-md-12">
                              <h4 className="text-danger text-center">ATTENZIONE! Questa operazione non è reversibile</h4>
                          </div>
                          {this.state.closingWaitingListErrors && (
                            <div className="text-center text-danger">
                                {this.state.closingWaitingListErrors}
                            </div>
                          )}
                          {this.state.closingWaitingList && (
                            <div className="text-center info">
                                Chiusura in corso...
                            </div>
                          )}
                          <div className="col-md-12 text-center">
                              <a onClick={this.closeWaitingList} style={{marginTop: 6, marginBottom: 15}} className="btn btn-info btn-lg">
                                  CONFERMA CHIUSURA LISTA
                              </a>
                          </div>

                      </div>
                  </React.Fragment>
              </Modal>
          </div>
        )
    }
}

export default Summary



// WEBPACK FOOTER //
// ./src/containers/Backoffice/BackofficeWaitingList/Details/Summary/Summary.js